import { makeStyles } from "@material-ui/core/styles";

const style = makeStyles((theme) => ({
  reservations: {
    display: "flex",
    justifyContent: "space-between",
    height: "80%",
    width: "90%",
    position: "absolute",
  },
  reservationsForm: {
    height: "100%",
    width: "40%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
  },
  reservationsTable: {
    height: "100%",
    width: "58%",
    overflow: "hidden",
  },
  inputsForm: {
    display: "flex",
    flexDirection: "column",
  },
  input: {
    margin: "10px",
  },
  actionButton: {
    width: "100%",
    margin: "10px",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 180,
    width: "100%",
  },
  inputRow: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "flex-end",
    alignContent: "center",
  },
}));

export default style;
